import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { BlowerFilterTableComponent } from '../../../shared/component/blower-filter-table/blower-filter-table.component';
import { DynamicFormModelComponent } from '../../../shared/component/dynamic-form-model/dynamic-form-model.component';
import { UnitConversionPipe } from '../../../shared/pipes/unit-conversion.pipe';
import { ChartFullscreenDialogComponent } from '../../../tabs/graph/chart-fullscreen-dialog/chart-fullscreen-dialog.component';
import { GraphComponent } from '../../../tabs/graph/graph.component';
import { ProductContentComponent } from './product-content.component';

@NgModule({
  declarations: [ProductContentComponent, BlowerFilterTableComponent, DynamicFormModelComponent, UnitConversionPipe, GraphComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTableModule,
    MatCheckboxModule,
    FormsModule,
    MatDialogModule,
    ChartFullscreenDialogComponent,
  ],
  exports: [ProductContentComponent, DynamicFormModelComponent, GraphComponent],
})
export class ProductContentModule {}
